module.exports = __webpack_public_path__ + "static/img/icon-pin-fill-hover.7abc3cf9.svg";